module.exports = __webpack_public_path__ + "img/protectiveGloves.87c94fa8.png";